import Vue from 'vue'
import Vuex from 'vuex'
import { fb_auth, fb_db, fb_users, fs } from '../firebase'
import differenceInDays from 'date-fns/differenceInDays'

Vue.use(Vuex)

var orderObserver;

// handle page reload
fb_auth.onAuthStateChanged(user => {
  if (user) {
    console.log('user exists, getting data...')
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')

    fb_users.doc(user.uid).onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })
  }
})

const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    config: {},
    weekday: null,
    week: null,
    day: null,
    dayinmenu: null,
    nomeal: null,
    orders: {
      breakfast: {
        complete: false,
        open: false,
        status: ''
      },
      lunch: {
        complete: false,
        open: false,
        status: ''
      },
      dinner: {
        complete: false,
        open: false,
        status: ''
      },
      brunch: {
        complete: false,
        open: false,
        status: ''
      },
      supper: {
        complete: false,
        open: false,
        status: ''
      },
    },
  },
  actions: {
    fetchUserProfile({commit,state}) {
      fb_users.doc(state.currentUser.uid).get().then(res => {
        commit('setUserProfile', res.data())
      }).catch(err => {
        console.log(err)
      })
    },
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
      orderObserver()
    },
    updateProfile({state}, data) {
      fb_users.doc(state.currentUser.uid).update({
        firstanme: data.firstname,
        lastname: data.lastname,
        uic: data.uic,
      }).then(user => {
        //user updated, return user
      }).catch(err => {
        console.log(err)
      })
    },
    async getConfig({ commit }) {
      const res = await fb_db.collection('config').get();
      let payload = {};
      res.forEach(doc => {
        payload[doc.id] = doc.data();
      })
      commit('setConfig', payload);
    },
    async getOrders({ state, commit }) {
      let start = new Date();
      start.setHours(0,0,0,0);
      const orderQuery = fb_db.collection('orders')
        .where('user', '==', state.currentUser.uid)
        .where('ts', '>', start);
      orderObserver = orderQuery.onSnapshot(querySnapshot => {
        this.orders = [];
        querySnapshot.forEach(async (doc) => {
          let item = doc.data();
          item.id = doc.id;
          const meal = await fb_db.collection('meals').doc(item.meal).get();
          const user = await fb_db.collection('users').doc(item.user).get();
          item.meal = meal.data();
          item.user = user.data();
          commit('setOrder', {
            meal: item.type,
            order: item
          });
        });
      }, err => {
        console.error(`Encountered error: ${err}`);
      });

      // let start = new Date();
      // start.setHours(0,0,0,0);
      // //const user = fb_db.collection('users').doc(state.currentUser.uid);
      // const res = await fb_db.collection('orders')
      //   .where('user', '==', fb_auth.currentUser.uid)
      //   .get();
      // res.forEach(doc => {
      //   let item = doc.data();
      //   item.id = doc.id;
      //   if (item.ts.toDate() >= start) {
      //     console.log('added item: ',item)
      //     commit('setOrder', {
      //       meal: item.type,
      //       order: item
      //     });
      //   }        
      // })
      
    },
    async setMeals({state, commit}) {
      let now = new Date();
      let scheduleStart = new Date(state.config.menu.begin);
      console.log(scheduleStart)
      let dayinmenu = (Math.abs(differenceInDays(scheduleStart, now)) + 1);
      //console.log('Menu start: ', scheduleStart, differenceInDays(scheduleStart, now))
      let dayinweek = null;
      let week = null;
      console.log('Days from menu start: ', dayinmenu)
      if (dayinmenu > 21) {
        dayinmenu = dayinmenu - (Math.floor(dayinmenu/21) * 21); 
      }
      week = dayinmenu/7
      if (week < 1) {
        week = 1
      } else if (week < 2) {
        week = 2
      } else {
        week = 3
      }
      dayinweek = dayinmenu - (Math.floor(dayinmenu/7) * 7);
      console.log('Day in menu: ', dayinmenu,' week: ', week,' Day in week: ', dayinweek)
      commit('setDayAndWeek',{
        day: dayinweek,
        dayinmenu: dayinmenu,
        week: week
      });
      let day = parseInt(now.getDay());
      if (day == 0 || day == 6) {
        console.log('weekend')
        commit('setWeekday', false)
      } else {
        console.log('weekday')
        commit('setWeekday', true)
      }
      let time = parseInt(now.getHours().toString() + ('0' + now.getMinutes()).slice(-2).toString());
      console.log('time: ',time)
      if (time > state.config.breakfast.start && time < state.config.breakfast.end && state.weekday) {
        console.log('breakfast open');
        commit('setMeal',{
          meal: 'breakfast',
          open: true
        })
      } else {
        console.log('breakfast closed');
        commit('setMeal',{
          meal: 'breakfast',
          open: false
        })
      }
      if (time > state.config.lunch.start && time < state.config.lunch.end && state.weekday) {
        console.log('lunch open');
        commit('setMeal',{
          meal: 'lunch',
          open: true
        })
      } else {
        console.log('lunch closed');
        commit('setMeal',{
          meal: 'lunch',
          open: false
        })
      }
      if (time > state.config.dinner.start && time < state.config.dinner.end && state.weekday) {
        console.log('dinner open');
        commit('setMeal',{
          meal: 'dinner',
          open: true
        })
      } else {
        console.log('dinner closed');
        commit('setMeal',{
          meal: 'dinner',
          open: false
        })
      }
      if (time > state.config.brunch.start && time < state.config.brunch.end && !state.weekday) {
        console.log('brunch open');
        commit('setMeal',{
          meal: 'brunch',
          open: true
        })
      } else {
        console.log('brunch closed');
        commit('setMeal',{
          meal: 'brunch',
          open: false
        })
      }
      if (time > state.config.supper.start && time < state.config.supper.end && !state.weekday) {
        console.log('supper open');
        commit('setMeal',{
          meal: 'supper',
          open: true
        })
      } else {
        console.log('supper closed');
        commit('setMeal',{
          meal: 'supper',
          open: false
        })
      }
      if (!state.orders.breakfast.open && !state.orders.lunch.open && !state.orders.dinner.open && !state.orders.brunch.open && !state.orders.supper.open) {
        console.log('no meals open')
        commit('setNomeal', true)
      } else {
        console.log('meal open')
        commit('setNomeal', false)
      }
    },
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setConfig(state, val) {
      state.config = val
    },
    setMeal(state, val) {
      state.orders[val.meal].open = val.open;
    },
    setOrder(state, val) {
      Object.assign(state.orders[val.meal], val.order)
      state.orders[val.meal].complete = true
    },
    setWeekday(state, val) {
      state.weekday = val;
    },
    setNomeal(state, val) {
      state.nomeal = val;
    },
    setDayAndWeek(state, val) {
      state.day = val.day + 1,
      state.week = val.week,
      state.dayinmenu = val.dayinmenu
    },
  }
})

export default store